import { FontWeight } from '@pasteltech/theme-provider'
import { memo } from 'react'
import { styled } from 'styled-components'
import { DeepNullable, ScreenQuery } from '../../utilities'
import { StrapiImage, StrapiImageData } from '../strapi-image'

const IntroductionContainer = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  ${ScreenQuery.mobile} {
    flex-direction: column-reverse;
    gap: ${({ theme }) => theme.sizes.spacings.xl}px;
  }
  ${ScreenQuery.tablet} {
    flex-direction: column-reverse;
    gap: ${({ theme }) => theme.sizes.spacings.xl}px;
  }
`
const LeftContainer = styled.div`
  flex: 0 0 50%;
`
const RightContainer = styled.div`
  flex: 0 0 50%;
`
const TitleAndContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.sizes.spacings.xl}px;
  align-self: stretch;
  height: 100%;
  width: 50%;
  margin: 0 auto;
  ${ScreenQuery.mobile} {
    width: 90%;
  }
  ${ScreenQuery.tablet} {
    width: 80%;
  }
`
const Title = styled.div`
  color: ${({ theme }) => theme.colors.text.high};
  font-size: ${({ theme }) => theme.sizes.fontSize.heading2}px;
  font-weight: ${FontWeight.bold};
`
const Content = styled.div`
  color: ${({ theme }) => theme.colors.text.medium};
  font-size: ${({ theme }) => theme.sizes.fontSize.subtitle}px;
  font-weight: ${FontWeight.medium};
`
const StyledStrapiImage = styled(StrapiImage)`
  object-fit: cover;
  height: 100%;
  width: 100%;
`

type Introduction = null | DeepNullable<{
  title: string
  content: string
  image: StrapiImageData
}>
type Props = {
  data: Introduction
}
export const IntroductionSection = memo(({ data }: Props) => {
  return (
    <IntroductionContainer>
      <LeftContainer>
        <TitleAndContentContainer>
          <Title>{data?.title}</Title>
          <Content>{data?.content}</Content>
        </TitleAndContentContainer>
      </LeftContainer>
      <RightContainer>
        <StyledStrapiImage strapiImage={data?.image} />
      </RightContainer>
    </IntroductionContainer>
  )
})

IntroductionSection.displayName = 'IntroductionSection'
